const documentSize = () => {
    document.documentElement.style.setProperty('--doc-height', window.innerHeight + 'px');
    document.documentElement.style.setProperty('--doc-width', window.innerWidth + 'px');
}

window.addEventListener('resize', documentSize);
window.addEventListener('scroll', documentSize);

documentSize();
